module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-eBook.4c4ada3d.png";